import { render, staticRenderFns } from "./aiOrg.vue?vue&type=template&id=ca9d56a2&scoped=true&"
import script from "./aiOrg.vue?vue&type=script&lang=js&"
export * from "./aiOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d56a2",
  null
  
)

export default component.exports